import * as PROJECT_CODE from '../../../constants/projectCode';
import * as SHOW_DECOR  from '../../../constants/showDecor'
import * as UNREAL_TO_DB from '../../../api/3DController/ReceiveMessageToDatabase.api.js'

export var onUnityUpdateMessage = { 
        callback: (()=>{console.log("Perform Action Receive Message")}),
        currentDataString: '',
        lastDataString: '',
        currentData: {},
        currentUnit: {},
        currentUserInfo: {},
        currentHostIp: '',
        setLoading: (()=>{console.log("Not connected to unity controller Loading Yet")}),
        setFurioosOff: (()=>{console.log("Not connected to unity controller furioos off Yet")}),
        getUnitsByCategory: (()=>{console.log("getUnitsByCategory not connected to unity controller yet")}),
        getUnitRooms: (()=>{console.log("getUnitRooms not connected to unity controller yet")}),
        getAllUpgrades: (()=>{console.log("getAllUpgrades not connected to unity controlle yet")}),
        getRoomUpgrades: (()=>{console.log("getRoomUpgrades not connected to unity controller yet")}),
        goToRoom: (()=>{console.log("goToRoom not connected to unity controller")}),
        goToUnit: (()=>{console.log("goToUnit not connected to unity controller yet")}),
        setOption: (()=>{console.log("setOption not connected to unity controller yet")}),
        goBack: (()=>{console.log("go back not attached to unity controller yet")}),
        zoomTo: (()=>{console.log("zoom to has not been set yet");}),
        setStateToDoNothing: (()=>{console.log("not attached to unity controller yet");}),
        messageClientHostIp: (()=>{console.log("messageClientHostIp not attached yet");})
    };

export function ReceiveMessageFromUnity(_data, currentUiState){

    var returnMessage = {
        updateState: false,
        newState: '',
        newMessageKey: '',
        newMessage: {},
    }

    try
    {
        var jsonMessage = JSON.parse(_data);

        var allKeys = Object.keys(jsonMessage);

        var firstKey = allKeys[0];


        switch(firstKey){
            case 'unityReady':
                console.log("Unity Ready ", jsonMessage[firstKey]);
                returnMessage.newMessageKey = firstKey;
                returnMessage.newMessage = jsonMessage[firstKey];
                return returnMessage;
            case 'avatarCreatedCode':
                console.log('avatarCreatedCode ', jsonMessage[firstKey]);
                returnMessage.newMessageKey = firstKey;
                returnMessage.newMessage = jsonMessage[firstKey];
                return returnMessage;
            case 'endSession':
                console.log("end session ", jsonMessage[firstKey]);
                returnMessage.newMessageKey = firstKey;
                returnMessage.newMessage = jsonMessage[firstKey];
                return returnMessage;
            case 'extendedSession':
                console.log("extendedSession ", jsonMessage[firstKey]);
                returnMessage.newMessageKey = firstKey;
                returnMessage.newMessage = jsonMessage[firstKey];
                return returnMessage;
            case 'allCategories':
                console.log("allCategories ", jsonMessage[firstKey]);
                returnMessage.updateState = true;
                returnMessage.newState = 'showCategories';
                returnMessage.newMessageKey = firstKey;
                returnMessage.newMessage = jsonMessage[firstKey];
                return returnMessage;
            case 'populateUnits' :
                console.log("populateUnits ", jsonMessage[firstKey]);
                returnMessage.updateState = true;
                returnMessage.newState = 'showUnits';
                returnMessage.newMessageKey = firstKey;
                returnMessage.newMessage = jsonMessage[firstKey];
                return returnMessage;
            case 'populateRooms':
                console.log("populateUnits ", jsonMessage[firstKey]);
                returnMessage.updateState = true;
                returnMessage.newState = 'showRoomsZoomedOut';
                returnMessage.newMessageKey = firstKey;
                returnMessage.newMessage = jsonMessage[firstKey];

                return returnMessage;
            //this area maybe used later
            // case 'populateAllUpgrades':
            //     console.log("populateAllUpgrades ", jsonMessage[firstKey]);
            //     returnMessage.updateState = true;
            //     returnMessage.newState = 'showUpgradeSelection';
            //     returnMessage.newMessageKey = firstKey;
            //     returnMessage.newMessage = jsonMessage[firstKey];
            //     return returnMessage;
            case 'currentUpgrades':
                console.log("currentUpgrades ", jsonMessage[firstKey]);

                if(SHOW_DECOR.showDecor === true){
                    returnMessage.updateState = true;
                }
                else{
                    returnMessage.updateState = false;
                }

                returnMessage.newState = 'showUpgradeOptions';
                returnMessage.newMessageKey = firstKey;
                returnMessage.newMessage = jsonMessage[firstKey];
                return returnMessage;
            case 'setRoomIp':
                console.log("SetRoomIp");
                UNREAL_TO_DB.setUnrealHostIp(jsonMessage, onUnityUpdateMessage.currentUserInfo);
                return returnMessage;
            default:
                console.log("Broken SDK message");
                break;
        }
    }
    catch(err){
        console.log("Broken Json: " , err);
        return returnMessage;
    }

}

export function GoOneStateBack(currentUiState){
    console.log("Go back current ui state ", currentUiState);
    var returnVal = {
        returningState: 'error',
        callback: (()=>{console.log('callback not set')})
    }

    switch(currentUiState){
        case 'doNothing':
            return('error');
        case 'loading':
            return ('error');
        case 'showCategories':
            return('error');
        case 'showUnits':
            returnVal.returningState = 'showCategories';
            return(returnVal);
        case 'showRoomsZoomedOut':
            returnVal.returningState = 'showUnits';
            return(returnVal);
        case 'showUpgradeOptions':
            returnVal.returningState = 'showRoomsZoomedOut';
            return(returnVal);
        case 'showUpgradeSelection':
            returnVal.returningState = 'showUpgradeOptions';
            return(returnVal);
        default:
            console.log("SHOULD NEVER BE HERE");
    }
}


// this.player.onSDKMessage(function (data) {
//     console.log('Message received from my application: ', data);

//     console.log(data.unityReady);

//     var dataRemovedBracket = data.replace('}', '');
//     dataRemovedBracket = dataRemovedBracket.replace('{', '');

//     console.log('Data removed bracket = ' + dataRemovedBracket);
//     // {unityReady:true}
//     var splitMessage = dataRemovedBracket.split(':');
//     var dataString0 = splitMessage[0];

//     //Get user info
//     if (dataString0 === 'unityReady') {
//         if (splitMessage[1] === 'true') {
//             //player.maximize();
//             //for image file
//             // console.log(imageFile);
//             //var thisBody = {test:"test"};

//             console.log('user time: ' + userAppointmentTimeUnix);
//             var thisBody = {
//                 userInfo: {
//                     email: userEmail,
//                     name: userFullName,
//                     phoneNumber: userPhoneNumber,
//                     avatarCode: userAvatarCode,
//                     userAppointmentTime: userAppointmentTimeUnix,
//                     userType: thisUserType,
//                     appId: thisAppointmentId,
//                     userId: thisUserId,
//                     image: imageFile,
//                 },
//             };
//             console.log('BODY BEING SENT ' + JSON.stringify(thisBody));
//             //var thisBody = {userInfo:{email: userEmail, name: userFullName, phoneNumber: userPhoneNumber, avatarCode: userAvatarCode, userAppointmentTime: userAppointmentTimeUnix, image: imageFile, userType: thisUserType, appId: thisAppointmentId, userId: thisUserId}};
//             try {
//                 self.player.sendSDKMessage(thisBody);
//             } catch (err) {
//                 console.log(
//                     'seems we get multiple players alive but they should be gone? ' +
//                         err
//                 );
//             }
//             console.log("Going to get categories now");
//             self.getCategories();
//         }
//     }

//     if (dataString0 === 'avatarCreatedCode') {
//         if (splitMessage[1]) {
//             userAvatarCode = splitMessage[1];

//             console.log('GOT USER AVATAR ' + userAvatarCode);

//             var currentUser = firebase.auth().currentUser;
//             var thisUid = currentUser.uid;

//             var userPostRef = firebase
//                 .database()
//                 .ref('/users/' + thisUid + '/avatarCode');

//             userPostRef.set(userAvatarCode);
//         }
//     }
//     //my build
//     if (dataString0.includes('unit') && !dataString0.includes('unity')) {
//         var removedRooms = dataRemovedBracket.replace('"rooms":[', '');
//         var splitComma = removedRooms.split(',');

//         createHtmlFromArray(splitComma);
//         // var emailGuestPost4 = app.database().ref('/myBuildEmails/' + project_code).push();

//         // emailGuestPost4.set({
//         //     email: userEmail,
//         //     build: "EMAIL STUFF"
//         // });
//     }

//     //ShutDown
//     //Get user info
//     if (dataString0.includes('endSession')) {
//         if (splitMessage[2].includes('True')) {
//             try {
//                 self.player.stop();
//             } catch (err) {
//                 console.log(
//                     'seems we get multiple players alive but they should be gone? ' +
//                         err
//                 );
//             }
//             //FinishFurioosCallBack();
//         } else if (splitMessage[2].includes('False')) {
//             try {
//                 self.player.stop();
//             } catch (err) {
//                 console.log(
//                     'seems we get multiple p[layers alive but they should be gone? ' +
//                         err
//                 );
//             }
//         }
//     }

//     //ExtendTime
//     if (dataString0 === 'extendedSession') {
//         UseAnotherAppointment();
//     }

//     //this is where we will handle the new message system

//     //allCategories
//     //populateUnits
//     //populateRooms
//     //populateRoomUpgrades
//     //optionName
//     //optionPrice
//     //urlRef
//     //id
//     console.log("Data: " + data);
//     var dataJson = JSON.parse(data);


//     if(dataString0.includes("allCategories")){
//         var allCats = dataJson.allCategories;
//         console.log("DATA : " + dataJson);
//         console.log("CATEGORY INFO BEING CALLED");
//         self.populateCategories(allCats, self.leftUiHolder, self.populatedUILeft);
//         self.changeUIState("inCategory", self.currentUiState);
//     }

//     if(dataString0.includes("populateUnits")){
//         var allUnits = dataJson.populateUnits;
//         self.populateUnits(allUnits, self.rightUiHolder, self.populatedUIRight)
//         self.changeUIState("inUnit", self.currentUiState);
//     }

//     if(dataString0.includes("populateRooms")){
//         var allRooms = dataJson.populateRooms;
//         self.populateRooms(allRooms, self.rightUiHolder, self.populatedUIRight);
//         console.log("check current state " + self.currentUiState);
//         if(self.currentUiState === "inUnit"){
//             //this.currentUiState = "inRoom";
//             self.changeUIState("inRoom", self.currentUiState);
//         }
//         else if(self.currentUiState === "inRoomZoom"){
//             //this.currentUiState = "inRoom";
//             self.changeUIState("inRoom", self.currentUiState);
//         }
//         else{
//             //this.currentUiState = "inRoomZoom";
//             self.changeUIState("inRoomZoom", self.currentUiState);
//         }
//     }

//     if(dataString0.includes("populateAllUpgrades")){
//         var upgrades = dataJson.populateAllUpgrades;
//         self.populateAllUpgrades(upgrades, self.rightUiHolder, self.populatedUIRight);
//     }

//     if(dataString0.includes("currentUpgrades")){
//         var roomUpgrades = dataJson.currentUpgrades;
//         self.populateUpgradeSelection(roomUpgrades, self.rightUiHolder, self.populatedUIRight);
//         self.changeUIState("inUpgrade", this.currentUiState);
//     }
    
    
// });